import styled from 'styled-components';

export const $QualiReparLogo = styled.img`
  max-height: 42px;
`;
